import { render, staticRenderFns } from "./SocietyMatchesRequestPayment.vue?vue&type=template&id=67396af3&scoped=true"
import script from "./SocietyMatchesRequestPayment.vue?vue&type=script&lang=js"
export * from "./SocietyMatchesRequestPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67396af3",
  null
  
)

export default component.exports